export const ross1000 = {
  title: "ROSS 1000 / Turismo5",
  subtitle: "Statistiques des flux touristiques — déclaration régionale",

  fields: {
    region: "Région",
    codice: "Code de structure",
    codiceHint: "Code de structure attribué par la région (le champ «codice»).",
    username: "Nom d'utilisateur",
    password: "Mot de passe",
    passwordHint: "Identifiants du service web ROSS 1000 (délivrés par la région / GIES).",
    prodotto: "Nom du logiciel",
    camereDisponibili: "Chambres disponibles",
    lettiDisponibili: "Lits disponibles",
    defaultTipoturismo: "Type de tourisme (par défaut)",
    defaultMezzotrasporto: "Moyen de transport (par défaut)",
    useTestEndpoint: "Utiliser l'environnement de test",
    endpointResolved: "Endpoint",
    keepBlank: "(laisser vide pour conserver la valeur actuelle)",
  },

  regionOptions: {
    sardegna: "Sardaigne",
    lazio: "Latium",
    veneto: "Vénétie",
    emilia_romagna: "Émilie-Romagne",
    toscana: "Toscane",
    piemonte: "Piémont",
    lombardia: "Lombardie",
    liguria: "Ligurie",
    marche: "Marches",
    abruzzo: "Abruzzes",
    molise: "Molise",
    calabria: "Calabre",
    basilicata: "Basilicate",
  },

  actions: {
    saveAndVerify: "Enregistrer et vérifier",
    updateCredentials: "Mettre à jour les identifiants",
    verifyConnection: "Vérifier la connexion",
    saving: "Enregistrement...",
    verifying: "Vérification...",
  },

  status: {
    connectionOk: "Identifiants enregistrés et connexion vérifiée avec succès.",
    connectionError: "Erreur de connexion. Vérifiez les identifiants saisis.",
    connectionPending: "Connexion pas encore vérifiée. Cliquez sur «Vérifier la connexion» pour confirmer.",
  },

  validation: {
    codiceRequired: "Le code de structure est obligatoire.",
    usernameRequired: "Le nom d'utilisateur est obligatoire.",
    passwordRequired: "Le mot de passe est obligatoire.",
    capacityRequired: "Saisissez les chambres et lits disponibles.",
  },

  toasts: {
    saveSuccess: "Identifiants enregistrés et connexion vérifiée avec succès.",
    saveWarning: "Identifiants enregistrés, mais la connexion n'a pas pu être vérifiée.",
    saveError: "Impossible d'enregistrer les identifiants.",
    testSuccess: "Connexion à ROSS 1000 vérifiée avec succès.",
    testError: "Impossible de vérifier la connexion.",
    statusActive: "ROSS 1000 activé.",
    statusInactive: "ROSS 1000 désactivé.",
  },
};